import {
  convertWorkStatusViaKey,
  createPrefTimeArray,
  createUserModelObj,
  getBranchForId,
  getUserRoleObjectForKey,
  getUserToggleEnabled,
} from "./dataProvider";
import { BranchModel, EnumUserAcces, UserModel } from "./dataStructures";
import { fetchLogOut } from "./wepApiManager";
//import { getDummyUsers } from "./dummyDataProvider";

/**
 * Checks if the user is logged in by verifying the presence of an authentication token in local storage.
 *
 * @returns {boolean} - Returns `true` if the user is logged in, otherwise `false`.
 */
export function isUserLoggedIn() {
  const lsData: string | null = localStorage.getItem("akyuz-cookie-auth");
  if (lsData !== null && lsData !== "") {
    const tempData: string = lsData as string;
    const cd = JSON.parse(tempData);
    if (cd.auth_token !== null) {
      return true;
    }
  }

  return false;
}

export function getEncryptionKey() {
  // bcrypt.genSalt(1, (err: Error | null, salt: string) => {
  //   console.log("Salt=" + salt);
  // });
  return "$2a$10$CwTycUXWue0Thq9StjUM0u";
}

export function getAuthToken() {
  const lsData: string | null = localStorage.getItem("akyuz-cookie-auth");
  if (lsData !== null) {
    const tempData: string = lsData as string;
    const cd = JSON.parse(tempData);
    return cd.auth_token;
  }
  return null;
}

export function getUserAccess() {
  const user = getCurrentUser();
  return user.role.type;
}

export function setUserPassword(password_: string) {
  const currentUser: UserModel | null = getProfileData();
  const auth_token: string | null = getAuthToken();
  if (currentUser !== null && auth_token !== null) {
    const userData = {
      password: password_,
      auth_token: auth_token,
      user_id: currentUser.user_id,
      email_id: currentUser.email_id,
      employee_id: currentUser.employee_id,
      about_us: currentUser.about_us,
      profile_pic_url: currentUser.profile_pic_url,
      first_name: currentUser.first_name,
      last_name: currentUser.last_name,
      mobilePrefix: currentUser.mobilePrefix,
      mobile: currentUser.mobile,
      address: currentUser.address,
      working_status: convertWorkStatusViaKey(currentUser.working_status.key),
      user_city: currentUser.user_city,
      user_state: currentUser.user_state,
      user_zipcode: currentUser.user_zipcode,
      permanent_branch_id: currentUser.permanent_branch_id,
      permanant_branch: getBranchForId([], currentUser.permanent_branch_id),
      role: getUserRoleObjectForKey(currentUser.role.key),
      pref_time: createPrefTimeArray(),
      gender: currentUser.gender,
    };
    localStorage.setItem("akyuz-cookie-auth", JSON.stringify(userData));
  }
}

export function getCurrentUser() {
  const user = getProfileData();
  if (user !== null) {
    return user;
  }

  return createUserModelObj();
  //return getDummyUsers()[0];
}

export function getIsMenuAltered() {
  const userAccess = getUserAccess();
  switch (userAccess) {
    case EnumUserAcces.SHIFT_PLANER:
      return true;
    case EnumUserAcces.BRANCH_MANAGER:
      return true;
    case EnumUserAcces.EMPLOYEE:
      return false;
  }

  return false;
}

export function processlogOut(callback: (isSuccess: boolean) => void) {
  fetchLogOut((isSuccess: boolean) => {
    if (isSuccess) {
      clearProfileData();
      callback(true);
    }
  });
}

function getProfileData() {
  const lsData: string | null = localStorage.getItem("akyuz-cookie-auth");
  if (lsData !== null && lsData !== "") {
    const tempData: string = lsData as string;
    const currentUser = JSON.parse(tempData);
    const branch: BranchModel = {
      branch_id: currentUser.permanant_branch.branch_id,
      name: currentUser.permanant_branch.name,
      address: currentUser.permanant_branch.address,
      phone: currentUser.permanant_branch.phone,
      contact_name: currentUser.permanant_branch.contact_name,
      contact_email: currentUser.permanant_branch.contact_email,
      contact_phone: currentUser.permanant_branch.contact_phone,
    };

    const user: UserModel = {
      user_id: currentUser.user_id,
      email_id: currentUser.email_id,
      employee_id: currentUser.employee_id,
      profile_pic_url: currentUser.profile_pic_url,
      first_name: currentUser.first_name,
      last_name: currentUser.last_name,
      mobilePrefix: currentUser.mobilePrefix,
      mobile: currentUser.mobile,
      address: currentUser.address,
      working_status: convertWorkStatusViaKey(currentUser.working_status.key),
      user_city: currentUser.user_city,
      user_state: currentUser.user_state,
      user_zipcode: currentUser.user_zipcode,
      permanent_branch_id: currentUser.permanent_branch_id,
      permanant_branch: branch,
      role: getUserRoleObjectForKey(currentUser.role.key),
      hourly_rate: currentUser.hourly_rate,
      pref_time: createPrefTimeArray(),
      password: currentUser.password,
      toggleAbility: getUserToggleEnabled(true),
      about_us: currentUser.about_us,
      gender: currentUser.gender,
    };

    return user;
  }
  return null;
}

export function saveProfileData(auth_token: string, currentUser: UserModel) {
  const userData = {
    auth_token: auth_token,
    user_id: currentUser.user_id,
    email_id: currentUser.email_id,
    employee_id: currentUser.employee_id,
    about_us: currentUser.about_us,
    profile_pic_url: currentUser.profile_pic_url,
    first_name: currentUser.first_name,
    last_name: currentUser.last_name,
    mobilePrefix: currentUser.mobilePrefix,
    mobile: currentUser.mobile,
    address: currentUser.address,
    working_status: convertWorkStatusViaKey(currentUser.working_status.key),
    user_city: currentUser.user_city,
    user_state: currentUser.user_state,
    user_zipcode: currentUser.user_zipcode,
    permanent_branch_id: currentUser.permanent_branch_id,
    permanant_branch: currentUser.permanant_branch,
    role: getUserRoleObjectForKey(currentUser.role.key),
    pref_time: createPrefTimeArray(),
    password: currentUser.password,
    hourly_rate: currentUser.hourly_rate,
    gender: currentUser.gender,
  };

  localStorage.setItem("akyuz-cookie-auth", JSON.stringify(userData));
}

export function clearProfileData() {
  localStorage.setItem("akyuz-cookie-auth", "");
}

export function getCurrentCurrency() {
  return "€";
}
